module.exports = __webpack_public_path__ + "media/images/features/5/main/main-1-27b75d48585959e6f2672c82934b9b4c.jpg";